import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { Route, Routes, Navigate, useLocation } from 'react-router';

import { WelcomePage } from './welcome.page';
import { ChooseWorkspacePage } from './choose-workspace.page';
import { OnBoardingLayout } from './on-boarding.layout';
import { OnboardingStepsIndicator } from './components/onboarding-steps-indicator';
import { StatsPage } from './stats.page';
import { UpdateProfilePage } from './update-profile.page';
import { fetchSpaces } from '../../features/spaces/stores/space.slice';
import { authStore } from '../../core/stores/auth-store';
import { CreateWorkspacePage } from './create-workspace.page';

export const OnBoardingPage: React.FC = () => {
  const user = authStore.currentUser;
  const [isReady, setReady] = useState(false);
  const location = useLocation();

  useEffect(() => {
    if (!user) {
      return;
    }

    fetchSpaces({ userId: user._id }).then(() => setReady(true));
  }, [user]);

  if (!isReady) {
    return null;
  }

  return (
    <OnBoardingLayout>
      <Container>
        <OnboardingStepsIndicator />

        <Routes>
          <Route path="/welcome" element={<WelcomePage />} />
          <Route path="/update-profile" element={<UpdateProfilePage />} />
          <Route path="/choose-workspace" element={<ChooseWorkspacePage />} />
          <Route path="/create-workspace" element={<CreateWorkspacePage />} />
          <Route path="/stats" element={<StatsPage />} />
          <Route
            path="/"
            element={<Navigate to={'/onboarding/welcome'} state={location.state} />}
          />
        </Routes>
      </Container>
    </OnBoardingLayout>
  );
};

const Container = styled.div`
  max-width: 37rem;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 3.2rem;
`;
